import Card from '../components/ui/Card';
import { Settings as SettingsIcon } from 'lucide-react';

export default function Settings() {
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      {/* Page Header */}
      <div className="flex items-center gap-3 mb-6">
        <SettingsIcon className="w-8 h-8 text-secondary-500" />
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">Settings</h1>
          <p className="text-sm text-neutral-600">Manage your application preferences</p>
        </div>
      </div>

      {/* Placeholder Content */}
      <Card>
        <div className="p-6">
          <div className="flex flex-col items-center justify-center py-12">
            <SettingsIcon className="w-16 h-16 text-neutral-300 mb-4" />
            <h2 className="text-xl font-semibold text-neutral-900 mb-2">Settings Coming Soon</h2>
            <p className="text-neutral-600 text-center max-w-md">
              User-specific settings and preferences will be available here in a future update.
              Stay tuned for more customization options!
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
